import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export function exportToExcel(allUrls: any, subjectName: string): void {
  const rows = allUrls.map(item => ({
    Disciplina: subjectName,
    Unidade: item.itemName,
    Link: item.url, // <-- ajuste aqui se necessário
  }));

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Links');

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

  saveAs(blob, `Links-${subjectName}.xlsx`);
}

export function exportToExcelCourseData(
  courseData: any,
  courseName: string,
): void {
  // Estrutura esperada: array de disciplinas, cada disciplina com nome e array de itens
  const rows: any[] = [];

  courseData.forEach((subject: any, index: number) => {
    // Adiciona os itens da disciplina com curso e disciplina preenchidos em todas as linhas
    if (subject.items && Array.isArray(subject.items)) {
      subject.items.forEach((item: any) => {
        rows.push({
          Curso: courseName,
          Disciplina: subject.subjectName || `Disciplina ${subject.subjectId}`,
          Unidade: item.itemName || item.name,
          Link: item.url,
        });
      });
    }

    // Se a disciplina não tem itens, adiciona pelo menos uma linha com a disciplina
    if (!subject.items || subject.items.length === 0) {
      rows.push({
        Curso: courseName,
        Disciplina: subject.subjectName || `Disciplina ${subject.subjectId}`,
        Unidade: '',
        Link: '',
      });
    }

    // Adiciona uma linha em branco entre disciplinas (exceto na última)
    if (index < courseData.length - 1) {
      rows.push({
        Curso: '',
        Disciplina: '',
        Unidade: '',
        Link: '',
      });
    }
  });

  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Links');

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

  saveAs(blob, `Links-${courseName}.xlsx`);
}
